import fetch from '../utils/fetch'

// 獲取信任登錄列表
export function getTrustLoginList (query) {
  return fetch({
    url: 'members/trustlogin/list',
    method: 'post'
    // params: query
  })
}

// 儲存信任登錄狀態
export function saveStatusSetting (query) {
  return fetch({
    url: 'members/trustlogin/setting',
    method: 'put',
    params: query
  })
}
